// Hey Joe Plus community Discord.
//
// The invite used to be a hardcoded constant here. Discord invites expire by
// default, so the CTA quietly started sending members to "Invite is expired"
// and stayed that way until someone noticed — and pasting a fresh code only
// restarts the same clock.
//
// The server now mints a permanent invite (max_age 0, max_uses 0), caches it,
// and re-validates it against Discord before handing it out, so a revoked code
// heals itself. Ask for it rather than shipping one.
let cached: string | null | undefined;
let inflight: Promise<string | null> | null = null;

export async function getCommunityInvite(): Promise<string | null> {
  if (cached !== undefined) return cached;
  if (!inflight) {
    inflight = fetch('/api/community/invite')
      .then(r => (r.ok ? r.json() : null))
      .then(d => { cached = d?.url || null; return cached; })
      .catch(() => { cached = null; return null; })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

// Opens the community. Resolves the invite first, so nobody is ever sent to a
// dead link — if there isn't one, this does nothing rather than opening an
// error page in a new tab.
export async function openCommunity(): Promise<boolean> {
  const url = await getCommunityInvite();
  if (!url) return false;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}
